import { Formik } from "formik";
import { get, set } from "lodash";
import React from "react";
import { useState } from "react";
import {
  CreateSpecificationInformation,
  LoaderWrapper,
  SliderPanel,
} from "../../../components";
import { ValidateCreateSpecificationSlider } from "../../../services";
import { formFields, manageFeeFormNames } from "../../../utils";

const formName = manageFeeFormNames.CALCULATION;
const fields = formFields[formName];

export const filterOutLastFeeTier = (values) => {
  const feeTiers = values ?? [];
  return feeTiers.filter(
    (_, ind) => feeTiers.length - 1 !== ind || _.isEditMode === false
  );
};

function CreateSpecificationSlider(props) {
  const {
    createSpecificationSliderOpen,
    setCreateSpecificationSliderOpen,
    feeType,
    initialValues,
    setOuterFieldValue,
    showErr,
    setShowErr,
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setErrors }
  ) => {
    {
      console.log(
        "onFormSubmit",
        values.feeTiers.every((v) => v.isEditMode === false)
      );
    }
    setIsLoading(true);
    let allFeeTierSave = values.feeTiers.every((v) => v.isEditMode === false);
    if (allFeeTierSave) {
      ValidateCreateSpecificationSlider(values)
        .then((res) => {
          setShowErr(false);
          setIsLoading(false);
          if (!res.isSuccessful) {
            let errorMessages = {};
            for (var i = 0; i < res.errorMessages.length; i++) {
              var _ = res.errorMessages[i];
              if (_.controlName === fields.feeTiers) {
                const fieldNameAccountBalanceFrom = `${
                  fields.feeTiers
                }.${0}.from`;
                const fieldNameAccountBalanceTo = `${fields.feeTiers}.${0}.to`;
                const fieldNameFeeAmount = `${
                  fields.feeTiers
                }.${0}.percentageOrAmountOrBasisPoints`;
                set(
                  errorMessages,
                  fieldNameFeeAmount,
                  `${_.errorCode} : ${_.message}`
                );
              } else if (_.controlName === "lastFeeTier") {
                set(
                  errorMessages,
                  `${fields.feeTiers}.${values[fields.feeTiers].length}.to`,
                  `${_.errorCode} : ${_.message}`
                );
                setErrors(errorMessages);
              }
              // else if (_.controlName == "lastFeeTier")
              // {

              //     errorMessages = {...errorMessages,[fields.feeTiers] : {
              //       ...errorMessages[fields.feeTiers],
              //       [values[fields.feeTiers].length-1]: {
              //         to :  `${_.errorCode} : ${_.message}`
              //       }
              //     }};

              // }
              else {
                setFieldTouched(_.controlName, true);
                set(
                  errorMessages,
                  _.controlName,
                  `${_.errorCode} : ${_.message}`
                );
              }
            }
            setErrors(errorMessages);
          } else {
            setOuterFieldValue(fields.feeSpecification, values);
            setCreateSpecificationSliderOpen(false);
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      setCreateSpecificationSliderOpen(true);
      setShowErr(true);
      setIsLoading(false);
    }
  };
  const translateRequest = (values) => {
    return {
      ...values,
      feeTiers: filterOutLastFeeTier(values[fields.feeTiers]).map(
        (tier, index) => {
          return {
            ...tier,
            order: index,
          };
        }
      ),
    };
  };

  return (
    <Formik
      initialValues={{
        createSpecificationSliderOpen: createSpecificationSliderOpen,
        ...initialValues,
        // [fields.feeTiers]: [
        //   ...get(initialValues, fields.feeTiers, []),
        //   {
        //     // from: "",
        //     // to: "",
        //     // percentageOrAmountOrBasisPoints: "",
        //     isEditMode: true,
        //   },
        // ],
        [fields.feeType]: feeType,
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          fieldValue,
          resetForm,
          dirty,
          validateForm,
          errors,
          ...rest
        } = formProps;
        console.log("values", values);
        return (
          <SliderPanel
            isOpen={createSpecificationSliderOpen}
            header={"Create Specification"}
            showSeparator={true}
            size="65"
            showHeader={true}
            showCancel={true}
            showSave={true}
            onClose={() => setCreateSpecificationSliderOpen(false)}
            backdropClicked={() => setCreateSpecificationSliderOpen(false)}
            onSave={() => {
              onFormSubmit(translateRequest(values), { ...formProps });
            }}
          >
            <LoaderWrapper isLoading={isLoading}>
              <CreateSpecificationInformation
                isMasterSpecification={false}
                showErr={showErr}
                fields={fields}
                {...props}
                {...formProps}
              />
            </LoaderWrapper>
          </SliderPanel>
        );
      }}
    </Formik>
  );
}

export default CreateSpecificationSlider;
